import React from 'react';
import AltSpeakerIcon from '../../../../../resources/icons/speaker_alt_avatar.png';
import ListItem from '../../../../elements/ListItem/ListItem';
import { ListItemContent } from '../../../../elements/ListItem/ListItemContent';
import { ListItemImage } from '../../../../elements/ListItem/ListItemImage';
import ScrollableList from '../../../../elements/ScrollableList';
import UserName from '../../../../elements/UserName/UserName';
import styles from '../../EventSpeakers.module.scss';

function SimpleSpeakersList({ speakers, savePositionKey }) {
    return (
        <ScrollableList className="" savePosition={savePositionKey}>
            {speakers.map((speaker, index) => (
                <ListItem tagName="div" key={index}>
                    <ListItemImage className={styles.photo} src={speaker.photo_url} altSrc={AltSpeakerIcon} size={50} round />
                    <ListItemContent href={['.', speaker.id].join('/')}>
                        <div className={['text', 'name', styles.name].join(' ')}>
                            <UserName user={speaker} />
                        </div>
                        <div className="text position">{speaker.position}</div>
                        <div className="text company">{speaker.company}</div>
                    </ListItemContent>
                </ListItem>
            ))}
        </ScrollableList>
    );
}

export default SimpleSpeakersList;
